import StyledField from 'common/TextField/TexField1';
import { Button, Grid } from '@mui/material';
import Filter from "common/Select/SelectMultiFilter";
import { useTranslation } from 'react-i18next';
import DynamicSelect from 'common/Select/Select';
import { themes } from 'theme/themes';
import { brandingInfo } from 'features/server/brandingSlice';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import DateRangePicker from 'common/Pickers/DateRangePicker';

interface PurchaseOrderSearchHeaderComponentProps {
  handleChangeFilter: (event: any) => void;
  handleChangeSearch: (field: string, value: any) => void;
  handleSubmitSearch: () => void;
  searchFormData: any;
  filter: string[];
  clearSearch: () => void;
  search: any;
  supplierData: any;
  StatusList: any;
  UrgencyStatusList: any;
  storeData: any;
  handleDropdownActions: (typeName: string, action: 'searchIt' | 'loadNext', search?: string) => void;
  dropdownPage: number; 
  searchLoading: string | null; 
  dropdownSearchTerm: any; 
  setDropdownSearchTerm: any;
  setDropdownPage: any;
  storesResponse: any;
  suppliersResponse: any;
  supplier?: number;
}

const PurchaseOrderSearchHeader: React.FC<PurchaseOrderSearchHeaderComponentProps> = ({
  handleChangeFilter,
  handleChangeSearch,
  handleSubmitSearch,
  searchFormData,
  filter,
  clearSearch,
  search,
  supplierData,
  StatusList,
  UrgencyStatusList,
  storeData,
  handleDropdownActions,
  storesResponse,
  suppliersResponse,
  dropdownPage, searchLoading, dropdownSearchTerm, setDropdownSearchTerm, setDropdownPage,
  supplier
}) => {
  const supplierOptions = supplierData.map((item: { id: number, title: string }) => ({
    value: item.id, 
    label: item.title
  }));
  const storeOptions = storeData.map((item: { id: number, title: string }) => ({
    value: item.id, 
    label: item.title
  }));
  const { t } = useTranslation();
  const branding = useSelector(brandingInfo);
  const themeColors = branding?.attributes?.themeId === 100 ? branding?.attributes?.customTheme : (themes as any)[branding?.attributes?.themeId || 3];
  const filterOptions = supplier ? ['poNumber', 'status', 'urgencyStatus', 'storeId', 'dateInterval'] : ['poNumber', 'status', 'urgencyStatus', 'supplierId', 'storeId', 'dateInterval'];
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSubmitSearch();
    }
  };
  
  return (
    <>
      <Grid container spacing={1} alignItems="flex-start">
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <Filter 
            label="Filter By"
            filterOptions={filterOptions}
            handleChangeFilter={handleChangeFilter}
            filter={filter}
          />
        </Grid>
        {filter.map((fieldName) => (
          <>
            {fieldName === 'dateInterval' ? <Grid item key={fieldName} xs={12} sm={6} md={3}>
                  <DateRangePicker
                    label=''
                    maxDate={dayjs()}
                    placeholder={'YYYY-MM-DD → YYYY-MM-DD'}
                    onChange={(value) =>
                      handleChangeSearch('dateInterval', [value?.[0] ? value[0].format('YYYY-MM-DD') : null, value?.[1] ? value[1].format('YYYY-MM-DD') : null,])
                    }
                    value={[
                      searchFormData?.startDate ? dayjs(searchFormData.startDate) : null,
                      searchFormData?.endDate ? dayjs(searchFormData.endDate) : null,
                    ]}
                  />
                </Grid>
                : fieldName === 'supplierId' ? 
                    <Grid item key={fieldName} xs={12} sm={6} md={3} lg={2}>
                      <DynamicSelect
                        value={searchFormData?.supplierId ? { value: searchFormData?.supplierId, label: searchFormData?.supplierTitle || searchFormData?.supplierId } : null}
                        isDisabled={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={true}
                        name="supplierId"
                        options={supplierOptions}
                        isRequired={true}
                        onChange={(e) => handleChangeSearch('supplierId', e)}
                        label=""
                        onKeyDown={handleKeyPress}
                        defaultPlaceholder={t('vendor')}
                        isLoading={searchLoading === 'suppliers'}
                        onInputChange={(search: string, { action }: { action: string }) => {
                          if(action === 'input-change' || 
                            (action !== 'set-value' && action !== 'menu-close' && action !== 'input-blur')
                          ) handleDropdownActions("suppliers", 'searchIt', search);
                          else if(action === 'input-blur' || action === 'menu-close') {
                            if(dropdownSearchTerm || dropdownPage > 1) handleDropdownActions("suppliers", 'searchIt', '');
                            else setDropdownSearchTerm('');
                            setDropdownPage(1);
                          }
                        }}
                        onMenuScrollToBottom={() => {if(!(suppliersResponse?.pages[0]?.data as any).last) handleDropdownActions("suppliers", 'loadNext')}}
                        page={dropdownPage}
                      />
                    </Grid> 
                : fieldName === 'storeId' ? 
                    <Grid item key={fieldName} xs={12} sm={6} md={3} lg={2}>
                      <DynamicSelect
                        value={searchFormData?.storeId ? { value: searchFormData?.storeId, label: searchFormData?.storeTitle || searchFormData?.storeId } : null}
                        isDisabled={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={true}
                        name="storeId"
                        options={storeOptions}
                        isRequired={true}
                        onChange={(e) => handleChangeSearch('storeId', e)}
                        label=""
                        onKeyDown={handleKeyPress}
                        defaultPlaceholder={t('store')}
                        isLoading={searchLoading === 'stores'}
                        onInputChange={(search: string, { action }: { action: string }) => {
                          if(action === 'input-change' || 
                            (action !== 'set-value' && action !== 'menu-close' && action !== 'input-blur')
                          ) handleDropdownActions("stores", 'searchIt', search);
                          else if(action === 'input-blur' || action === 'menu-close') {
                            if(dropdownSearchTerm || dropdownPage > 1) handleDropdownActions("stores", 'searchIt', '');
                            else setDropdownSearchTerm('');
                            setDropdownPage(1);
                          }
                        }}
                        onMenuScrollToBottom={() => {if(!(storesResponse?.pages[0]?.data as any).last) handleDropdownActions("stores", 'loadNext')}}
                        page={dropdownPage}
                      />
                    </Grid> 
                : fieldName === 'status' ? 
                    <Grid item key={fieldName} xs={12} sm={6} md={3} lg={2}>
                      <DynamicSelect
                        value={StatusList.find((option: any) => option.value === searchFormData?.status)}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={false}
                        isRtl={false}
                        isSearchable={true}
                        name="status"
                        options={StatusList}
                        isRequired={true}
                        onChange={(e) => handleChangeSearch('status', e)}
                        label=""
                        onKeyDown={handleKeyPress}
                        defaultPlaceholder={t('status')}
                      />
                    </Grid>
                : fieldName === 'urgencyStatus' ? 
                    <Grid item key={fieldName} xs={12} sm={6} md={3} lg={2}>
                      <DynamicSelect
                        value={UrgencyStatusList.find((option: any) => option.value === searchFormData?.urgencyStatus)}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={false}
                        isRtl={false}
                        isSearchable={true}
                        name="urgencyStatus"
                        options={UrgencyStatusList}
                        isRequired={true}
                        onChange={(e) => handleChangeSearch('urgencyStatus', e)}
                        label=""
                        onKeyDown={handleKeyPress}
                        defaultPlaceholder={t('Priority')}
                      />
                    </Grid>
                : <Grid item key={fieldName} xs={12} sm={6} md={3} lg={2}>
                    <StyledField
                        fullWidth={true}
                        placeholder={t(fieldName)}
                        displayPlaceholder={true}
                        handleChange={(e) => handleChangeSearch(fieldName, e.target.value)}
                        required={true}
                        // error={searchErrorMessages[fieldName]}
                        value={searchFormData?.[fieldName] || ''}
                        handleKeyDown={handleKeyPress}
                    />
                </Grid>
            }
          </>
        ))}
        <Grid item xs={12} sm={6} md={2} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
          <Button 
            variant="contained"
            disabled={filter.length ? false : true}
            onClick={handleSubmitSearch}
            sx={{
              boxShadow: 'none',
              background: filter.length > 0 ? themeColors?.primary : '#B8C0C6',
              height: 38,
              minHeight: 38,
            }}
            className={`text-white text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] px-8 py-1`}
          >{t('submit')}</Button>
          {filter.length && Object.keys(search).length || filter.length > 1 ?
            <Button 
            variant="contained"
            onClick={clearSearch}
            sx={{
              boxShadow: 'none',
              color: themeColors?.primary,
              height: 38,
              minHeight: 38,
            }}
            className={`text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] bg-[#d8d1e0] px-8 py-1`}
          >{t('clear')}</Button>: null}
          {/* {filter.length && Object.keys(search).length || filter.length > 1 ?
            <span 
              className={`font-Saira font-[600] text-[14px] leading-[19px] text-selectedborder-color ms-[10px] cursor-pointer underline`}
              onClick={clearSearch}
            >
              {t('Clear')}
            </span> : null
          } */}
        </Grid>
      </Grid>
    </>
  );
};

export default PurchaseOrderSearchHeader;